<template>
  <div class="card">
    <div class="card-header">
      <step-progress
        :steps="steps"
        :current-step="currentStep"
        icon-class="fa fa-check"
        active-color="green"
      ></step-progress>
    </div>
    <div class="card-body">
      <slot v-bind:currentStep="currentStep"></slot>
    </div>
    <div class="card-footer text-muted">
      <slot name="footer"> </slot>
      <button v-if="currentStep > 0" class="btn btn-primary" @click="prev">
        Lùi lại
      </button>
      <button
        v-if="currentStep != steps.length"
        class="btn btn-success"
        @click="next"
      >
        Tiếp theo
      </button>
      <template v-else>
        <button type="button" @click="complete(1)" class="btn btn-success">
          Lưu tiếp (Shift + F4)
        </button>
        <button type="button" @click="complete(0)" class="btn btn-default">
          Lưu đóng (F4)
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import StepProgress from "vue-step-progress";
import "vue-step-progress/dist/main.css";
export default {
  name: "step",
  props: {
    steps: {
      type: Array
    }
  },
  data() {
    return {
      currentStep: 0
    };
  },
  methods: {
    next() {
      this.$emit("next", this.currentStep, status => {
        if (status == true) {
          this.currentStep++;
        }
      });
    },
    prev() {
      this.currentStep--;
      this.$emit("prev");
    },
    complete(type) {
      this.$emit("complete", type);
    }
  },
  components: {
    "step-progress": StepProgress
  }
};
</script>
